import { createTheme } from '@mui/material/styles'

const ImperialTheme = createTheme({
    shape: {
        borderRadius: 16
    },
    palette: {
        mode: 'dark',
        primary: {
            main: '#6f9dff',
            light: '#a9c3ff',
            dark: '#406fce',
            contrastText: '#08111f'
        },
        secondary: {
            main: '#d7b768',
            light: '#ecd79f',
            dark: '#9f8037'
        },
        info: {
            main: '#73c9f1'
        },
        success: {
            main: '#6ed4a5'
        },
        warning: {
            main: '#f0b36d'
        },
        error: {
            main: '#f48484'
        },
        background: {
            default: '#09111c',
            paper: '#121c2b'
        },
        divider: 'rgba(255, 255, 255, 0.08)',
        text: {
            primary: '#f4f7fb',
            secondary: '#9ca9bb'
        }
    },
    typography: {
        fontFamily: '"Sora", "Segoe UI", sans-serif',
        h1: { fontFamily: '"Cinzel", serif', fontWeight: 700 },
        h2: { fontFamily: '"Cinzel", serif', fontWeight: 700 },
        h3: { fontFamily: '"Cinzel", serif', fontWeight: 700 },
        h4: { fontFamily: '"Cinzel", serif', fontWeight: 600 },
        h5: { fontWeight: 700 },
        h6: { fontWeight: 700 },
        button: {
            fontWeight: 600,
            textTransform: 'none',
            letterSpacing: '0.01em'
        }
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                ':root': {
                    colorScheme: 'dark'
                },
                body: {
                    backgroundColor: '#09111c',
                    backgroundImage: 'linear-gradient(180deg, #09111c 0%, #0d1624 100%)',
                    color: '#f4f7fb',
                    scrollbarColor: '#3f5576 rgba(255,255,255,0.06)',
                    '&::-webkit-scrollbar': {
                        width: '10px',
                        height: '10px'
                    },
                    '&::-webkit-scrollbar-track': {
                        background: 'rgba(255,255,255,0.04)'
                    },
                    '&::-webkit-scrollbar-thumb': {
                        borderRadius: '999px',
                        background: 'rgba(111, 157, 255, 0.55)',
                        border: '2px solid rgba(9, 17, 28, 0.9)'
                    }
                }
            }
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    backgroundImage: 'none',
                    backgroundColor: '#121c2b',
                    border: '1px solid rgba(255,255,255,0.06)',
                    boxShadow: '0 20px 45px rgba(1, 8, 18, 0.28)'
                }
            }
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    position: 'relative',
                    overflow: 'hidden',
                    background: 'linear-gradient(180deg, rgba(18, 28, 43, 0.98) 0%, rgba(12, 20, 32, 0.98) 100%)',
                    border: '1px solid rgba(255,255,255,0.06)',
                    boxShadow: '0 18px 38px rgba(3, 10, 20, 0.24)',
                    transition: 'border-color 160ms ease, box-shadow 160ms ease',
                    '&:hover': {
                        borderColor: 'rgba(111, 157, 255, 0.2)',
                        boxShadow: '0 22px 42px rgba(3, 10, 20, 0.28)'
                    }
                }
            }
        },
        MuiDrawer: {
            styleOverrides: {
                paper: {
                    background: 'linear-gradient(180deg, #101826 0%, #0b1320 100%)',
                    borderRight: '1px solid rgba(255,255,255,0.06)'
                }
            }
        },
        MuiAppBar: {
            styleOverrides: {
                root: {
                    backgroundImage: 'none',
                    boxShadow: 'none'
                }
            }
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 12
                },
                contained: {
                    background: '#6f9dff',
                    color: '#08111f',
                    boxShadow: '0 10px 24px rgba(111, 157, 255, 0.24)',
                    '&:hover': {
                        background: '#82abff',
                        boxShadow: '0 12px 26px rgba(111, 157, 255, 0.3)'
                    }
                },
                outlined: {
                    borderColor: 'rgba(255,255,255,0.12)',
                    color: '#f4f7fb',
                    '&:hover': {
                        borderColor: 'rgba(111, 157, 255, 0.34)',
                        backgroundColor: 'rgba(111, 157, 255, 0.08)'
                    }
                }
            }
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    borderRadius: 999,
                    border: '1px solid rgba(255,255,255,0.08)',
                    backgroundColor: 'rgba(255,255,255,0.04)'
                }
            }
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    borderRadius: 14,
                    backgroundColor: 'rgba(255,255,255,0.03)',
                    '& fieldset': {
                        borderColor: 'rgba(255,255,255,0.1)'
                    },
                    '&:hover fieldset': {
                        borderColor: 'rgba(111, 157, 255, 0.28)'
                    },
                    '&.Mui-focused fieldset': {
                        borderColor: '#6f9dff'
                    }
                }
            }
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    color: '#9ca9bb'
                }
            }
        },
        MuiLinearProgress: {
            styleOverrides: {
                root: {
                    borderRadius: 999,
                    backgroundColor: 'rgba(255,255,255,0.08)'
                }
            }
        },
        MuiDialog: {
            styleOverrides: {
                paper: {
                    background: 'linear-gradient(180deg, #141d2c 0%, #0d1522 100%)'
                }
            }
        }
    }
})

export default ImperialTheme
